import { enumLabel } from './enumLabel';

/**
 * horseEnumLabel — mapping d'AFFICHAGE des enums cheval (vague i18n 1.8a,
 * dette [i18n-horse-enums]). Wrapper du helper générique `enumLabel` (1.8b).
 *
 * Le code stocké en DB reste INCHANGÉ (FR/slug : 'cheval', 'hongre',
 * 'box-paddock'…). Seul l'affichage est traduit via `horses.enums.<field>.<value>`.
 * La `value` soumise au backend par les <select> ne passe jamais par ce helper.
 *
 * Enums fermés couverts : type, sex, housingType, bedding, feeding, country.
 * (shareRole → réutilise `roles.*` via roleLabel, hors de ce helper.)
 * Champs LIBRES (breed, coatColor, coat, city) : aucun mapping, jamais appelés ici.
 *
 * @param {string} field  - clé d'enum ('type', 'sex', 'housingType', 'bedding', 'feeding', 'country')
 * @param {string} value  - code DB (ex. 'cheval', 'hongre')
 * @param {Function} [t]  - fonction t du hook useTranslation ; à défaut, instance i18n
 *                          singleton (util non-React : buildHorseSubtitle, etc.)
 * @returns {string} libellé traduit, ou la valeur brute si la clé manque
 *                   (valeur legacy/inconnue → pas de clé affichée).
 */
export function horseEnumLabel(field, value, t) {
  return enumLabel('horses.enums', field, value, t);
}
